import React, {Fragment} from 'react'
import {useLoaderData, useRouteLoaderData} from '@remix-run/react'
import clsx from 'clsx'
import {getTranslation} from '~/localization/translation'
import type {CategoriesDataProps, RootLoaderResponse} from '~/types'
import {getDomainConfig} from '~/domains'
import {useReportWidgetSeen} from '~/hooks/analytic-hooks'
import TopDealsCard from './top-deals-card'

const Deals = () => {
  const {language, domain, locale} = useRouteLoaderData('root') as RootLoaderResponse
  const {newHomePageData} = useLoaderData() as CategoriesDataProps
  const {styles: stylesBydomain} = getDomainConfig(domain, locale)
  const {homepageData} = newHomePageData || {}

  const [widgetRef] = useReportWidgetSeen({
    widget_name: 'deals-of-the-day',
    widget_place: 'top',
  })
  const translations = getTranslation(language)

  const displayItems = homepageData?.dealsOfTheDay && homepageData?.dealsOfTheDay?.length > 1

  return displayItems ? (
    <div ref={widgetRef} className={clsx('mx-auto', stylesBydomain.UTILS_MAIN_CONTAINER)}>
      <h3 className="text-center text-xl font-semibold capitalize">{translations.Home.Deals.title}</h3>
      <div className="no-scrollbar mt-4 flex flex-row gap-6 overflow-x-scroll p-2">
        {homepageData?.dealsOfTheDay?.map((deal, i) => (
          <Fragment key={`${deal.asin}-${i}`}>
            <TopDealsCard productInfo={deal} index={i + 1} />
          </Fragment>
        ))}
      </div>
    </div>
  ) : null
}

export default Deals
